
import React, { ReactNode, useId } from "react"
import { ReactTooltip } from "tooltip"

const tooltips = {
    "slow": <>Recomendamos a escolha da velocidade <b>segura</b>, especialmente quando o Chip é novo ou foi desbloqueado recentemente, ou para envio de áudios e vídeos.</>,
    "normal": <>Recomendamos o envio padrão para aqueles que buscam uma velocidade <b>moderada</b>, com equilibrio entre rapidez e segurança.</>,
    "fast": <>Aconselhamos a opção <b>rápido</b> para usuários mais experientes que utilizam um Chip Aquecido, com histórico de conversas consolidado.</>,
} as const

type Speed =  "normal" | "fast" | "slow"

function Option({selected, onChange, label, value}: {selected: boolean, onChange:(e: Speed) => void, label: ReactNode, value: Speed}){
    const id = useId()
    return <div className="form-check mb-1">
        <input className="form-check-input" checked={selected} type="radio" name="speed" id={id} value={value} onChange={(e) => {if(e.target.checked) onChange(value)}} />
        <label className="form-check-label" htmlFor={id}>
            {label} <ReactTooltip className="ms-2" tooltip={tooltips[value]}><i className="fa fa-question-circle text-primary"></i></ReactTooltip>
        </label>
</div>

}

export function SpeedMenu({speed, onChange}:{speed: Speed | null, onChange:(e: Speed) => void }){
    return <>
        <div className='mt-3 mb-2'>Escolha o tipo de envio:</div>
        <Option label={<><i className="fa fa-person-walking"></i> Seguro <small className="text-muted">(Chip Novo / Recém Desbloqueado ≈40s)</small></>} value="slow" onChange={onChange} selected={speed == 'slow'} />
        <Option label={<><i className="fa fa-person-running"></i> Normal <small className="text-muted">(Moderado ≈15s)</small></>} value="normal" onChange={onChange} selected={speed == 'normal'} />
        <Option label={<><i className="fa fa-bolt"></i> Rápido <small className="text-muted">(Chip Aquecido ≈5s)</small></>} value="fast" onChange={onChange} selected={speed == 'fast'} />
    </>
}